import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosDummyInstance } from '@utils/axios/axiosInstance';
import { reduxThunkStatus } from '@configs/restApi';
import { keywordType, keywordGroupType, competitorsType } from '@models/keyword/keywordModel';

// 키워드 그룹 리스트
export const fetchKeywordGroupList = createAsyncThunk('fetchKeywordGroupList', async (params: { email: string }) => {
  try {
    return await axiosDummyInstance
      .get('/api/keyword/keywordGroup.json', { params: params })
      .then((response) => {
        const { status, data, statusText } = response;
        if (status === 200) {
          return data;
        } else {
          throw new Error(statusText);
        }
      })
      .catch((error) => {});
  } catch (error) {
    console.log('fetchKeywordGroupError: ', error);
  }
});

// requestKeywordList 요청
export const fetchReqKeywordList = createAsyncThunk('fetchRequestKeywordList', async (params: { email: string }) => {
  console.log('params: ', params);
  try {
    return await axiosDummyInstance
      .get('/api/keyword/BpartTrackingData.json', { params: params })
      .then((response) => {
        const { data, status, statusText } = response;
        if (status === 200) {
          return data.map((item) => item.keyword);
        } else {
          throw new Error(statusText);
        }
      })
      .catch((error) => {
        throw new Error(error);
      });
  } catch (error) {
    console.log('fetchKeywordListError: ', error);
  }
});

// Bpart keyword 리스트 요청 tracked, ranking 키워드 리스트!
export const fetchKeywordList = createAsyncThunk(
  'fetchKeywordList',
  async (params: { email: string; keywordList: string[] }) => {
    console.log('paramsBpartTracked,Ranking: ', params);
    try {
      return await axiosDummyInstance
        .get('/api/keyword/BpartTrackingData.json', { params: params })
        .then((response) => {
          const { data, status, statusText } = response;
          if (status === 200) {
            return data;
          } else {
            throw new Error(statusText);
          }
        })
        .catch((error) => {
          throw new Error(error);
        });
    } catch (error) {
      console.log('fetchKeywordListError: ', error);
    }
  }
);

// Bpart keyword 리스트 요청 competition 탭 키워드 리스트!
export const fetchCompetitorsList = createAsyncThunk(
  'fetchCompetitorsList',
  async (params: { email: string; keywordList: string[] }) => {
    console.log('paramsBpartCompetition: ', params);
    try {
      return await axiosDummyInstance
        .get('/api/keyword/BpartCompetitorKeyword.json', { params: params })
        .then((response) => {
          const { data, status, statusText } = response;
          if (status === 200) {
            return data;
          } else {
            throw new Error(statusText);
          }
        })
        .catch((error) => {
          throw new Error(error);
        });
    } catch (error) {
      console.log('fetchKeywordListError: ', error);
    }
  }
);

const initialState = {
  keywordGroupList: null as keywordGroupType[],
  requestKeywordList: null as string[], // bpart 키워드목록 요청 keyword 리스트
  keywordList: null as keywordType[], // tracked, ranking 탭에서 사용
  keywordListStatus: 'init' as reduxThunkStatus,
  competitorsList: null as competitorsType[], // competiton 탭에서 사용
  competitorsListStatus: 'init' as reduxThunkStatus,
};

export const keywordSlice = createSlice({
  name: 'keyword',
  initialState: initialState,
  reducers: {
    addRequestKeywordList: (state, { payload: { keyword } }) => {
      console.log('addRequestpayload: ', keyword);
      state.requestKeywordList = state.requestKeywordList.concat(keyword);
    },
    delRequestKeywordList: (state, { payload: { keyword } }) => {
      console.log('delRequestpayload: ', keyword);
      state.requestKeywordList = state.requestKeywordList.filter((item) => item !== keyword);
    },
    addKeywordList: (state, { payload: { keywordObj } }) => {
      state.keywordList.push(keywordObj);
    },
    deleteKeywordList: (state, { payload: { keyword } }) => {
      state.keywordList = state.keywordList.filter((obj) => obj.keyword !== keyword);
    },
  },
  extraReducers: {
    // 키워드 그룹 리듀서
    [fetchKeywordGroupList.fulfilled.type]: (state, { payload, meta: { requestId, arg } }) => {
      state.keywordGroupList = payload;
    },
    // reqKeywordList 리듀서
    [fetchReqKeywordList.fulfilled.type]: (state, { payload, meta: { requestId, arg } }) => {
      state.requestKeywordList = payload;
    },
    // Bpart 키워드 리스트 리듀서
    [fetchKeywordList.pending.type]: (state, { meta: { requestStatus } }) => {
      state.keywordListStatus = requestStatus;
    },
    [fetchKeywordList.fulfilled.type]: (state, { payload, meta: { requestStatus } }) => {
      state.keywordList = payload;
      state.keywordListStatus = requestStatus;
      // // 요청을 위한 keyword리스트 처리
      // state.requestKeywordList = payload.map((item) => item.keyword);
    },
    [fetchKeywordList.rejected.type]: (state, { error: { code, message, name, stack }, meta: { requestStatus } }) => {
      state.keywordListStatus = requestStatus;
    },
    // Bpart CompetitorsList 리듀서
    [fetchCompetitorsList.pending.type]: (state, { meta: { requestStatus } }) => {
      state.competitorsListStatus = requestStatus;
    },
    [fetchCompetitorsList.fulfilled.type]: (state, { payload, meta: { requestStatus } }) => {
      state.competitorsList = payload;
      state.competitorsListStatus = requestStatus;
    },
    [fetchCompetitorsList.rejected.type]: (
      state,
      { error: { code, message, name, stack }, meta: { requestStatus } }
    ) => {
      state.competitorsListStatus = requestStatus;
    },
  },
});

export const { addKeywordList, deleteKeywordList, addRequestKeywordList, delRequestKeywordList } = keywordSlice.actions;
export const keywordSliceName = keywordSlice.name;
export default keywordSlice.reducer;
